import {useAuth} from '@common/auth/use-auth';
import {useEffect} from 'react';
import {scheduleNativePushSync} from './native-push';

export function NativePushDeviceSync() {
  const {user} = useAuth();
  const userId = user?.id;

  useEffect(() => {
    if (!userId) {
      return;
    }

    scheduleNativePushSync(userId);

    const sync = () => scheduleNativePushSync(userId);
    window.addEventListener('sintonizy-native-push-ready', sync);

    return () => {
      window.removeEventListener('sintonizy-native-push-ready', sync);
    };
  }, [userId]);

  return null;
}
